import { Link } from "react-router-dom";

export default function Newsletter() {
    return (
        <>
            <section className="max-w-screen mx-auto    bg-black text-slate-950 ">

                <div className="grid md:grid-cols-2 gap-10 items-center">

                    {/* LEFT CONTENT */}
                    <div data-aos="fade-right" data-aos-duration="1000">
                        <Link to="/" className="text-2xl font-bold text-gray-900 rounded-lg  ">
                            <img src="assets/images/logo1.png" className="rounded-sm  w-[201px]" alt="logo" />
                        </Link>

                        <h2 className="text-3xl md:text-4xl bg-gradient-to-r  from-blue-500 via-purple-600 to-violet-700 bg-clip-text text-transparent font-bold mb-4">
                            Get Connected With Us!
                        </h2>

                        <p className="text-slate-100 leading-tight mb-6 ">
                            <b>PICKUPXPRESS</b> is your one-stop shop for all your shipping needs.
                            We offer a comprehensive suite of services to ensure your parcels,
                            ecommerce orders, and cargo reach their destinations efficiently
                            and securely.
                        </p>

                        <p className="text-xs text-slate-200 ">
                            ISO 9001: 2015, Certified Company CIN: UP63030UP2021PTC141702
                        </p>
                    </div>

                    {/* RIGHT INPUT */}
                    <div data-aos="fade-left" data-aos-duration="1000" className="w-full">
                        <div className="flex bg-white border border-slate-400 rounded-xl overflow-hidden backdrop-blur-md ">

                            <input
                                type="email"
                                placeholder="username@gmail.com"
                                className="flex-1 px-5 py-4 bg-transparent text-slate-950 placeholder-slate-500 outline-none "
                            />

                            <button className="bg-red-500 cursor-pointer hover:bg-red-600 px-6 md:px-8 text-white font-semibold transition-all">
                                GET IN TOUCH
                            </button>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}